var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-btn',{staticClass:"q-px-sm",attrs:{"flat":"","dense":"","size":"13px","icon":"far fa-unlock","label":"Logout","color":_vm.dark? 'white':'dark-gray'},on:{"click":function($event){return _vm.confirm()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }